var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"dialog-button",attrs:{"disabled":_vm.disabled,"color":"primary"},on:{"click":_vm.onClickExecute}},[_vm._v(" Execute ")])
}
var staticRenderFns = []

export { render, staticRenderFns }